import React, { useEffect } from 'react';
import { Button, Form, message, Spin } from 'antd';
import { LoadingOutlined, SaveOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { useLayoutContext } from '../../../../Layout/context';
import useUnsavedChanges from '../../../../../hooks/unsavedChanges';
import useComponentDidUpdate from '../../../../../hooks/componentDidUpdate';
import Content from '../../../../Common/Content';
import PageForm from '../../Form';
import { useSEOGetById, useSEOUpdate } from '../../../../../hooks/api/SEO';
import { useMessageError } from '../../../../../hooks/common';

import styles from './index.module.scss';

export default function PagesUpdate(): JSX.Element {
  const [form] = Form.useForm();
  const { pageId } = useParams();
  const seoGetById = useSEOGetById(pageId);
  const seoUpdate = useSEOUpdate(pageId);
  const navigate = useNavigate();
  const { setBreadcrumbs } = useLayoutContext();
  const { setInitData, check, setChanged, contextHolder, isChanged } = useUnsavedChanges();

  useMessageError([seoGetById, seoUpdate]);

  useEffect(() => {
    seoGetById.fetch();
    setBreadcrumbs([
      { title: 'Tipping pages', href: '/pages' },
      { title: <Spin size="small" indicator={<LoadingOutlined spin />} /> },
    ]);
  }, []);

  useComponentDidUpdate(() => {
    if (seoGetById.data && !seoGetById.error) {
      setBreadcrumbs([
        {
          title: 'Tipping pages',
          href: '/pages',
        },
        {
          title: seoGetById.data.name.slice(0, 100),
        },
      ]);

      setTimeout(() => setInitData(form.getFieldsValue()), 100);
    }
  }, [seoGetById.data]);

  useEffect(() => {
    if (seoUpdate.data && !seoUpdate.error && !seoUpdate.loading) {
      message.success(`Page ${form.getFieldValue('name').slice(0, 100)} updated successfully`);
      navigate('/pages');
    }
  }, [seoUpdate.data, seoUpdate.loading]);

  return (
    <>
      <div className={styles.header}>
        <h2>Update SEO page</h2>
        <div className={styles.actions}>
          <Button
            onClick={(e) => {
              e.preventDefault();
              // navigate('/categories');
              window.location.reload();
            }}
          >
            Cancel
          </Button>
          <Button
            icon={<SaveOutlined />}
            type="primary"
            loading={seoGetById.loading || seoUpdate.loading}
            onClick={() => {
              form.submit();
            }}
            disabled={!isChanged}
          >
            Save Changes
          </Button>
        </div>
      </div>

      <Content className={styles.content}>
        {seoGetById.data ? (
          <Form
            initialValues={{
              ...seoGetById.data,
              data: JSON.stringify(seoGetById.data.data),
            }}
            layout="vertical"
            className={styles.main}
            form={form}
            onFinish={(data) => {
              setInitData(data);

              const { pageId: category, ...values } = data;

              seoUpdate.fetch({
                ...values,
                data: JSON.parse(values.data),
              });
            }}
            onChange={() => setChanged(check(form.getFieldsValue()))}
          >
            <PageForm form={form} onChange={() => setChanged(check(form.getFieldsValue()))} />
          </Form>
        ) : (
          <Spin
            indicator={<LoadingOutlined spin />}
            style={{
              width: '100%',
              height: 200,
              display: 'flex',
              justifyContent: 'center',
              alignContent: 'center',
              alignItems: 'center',
            }}
          />
        )}
      </Content>

      {contextHolder}
    </>
  );
}
